<template>
  <el-dialog
      :visible.sync="visible"
      title="确认付款"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        ref="dataForm"
        label-width="100px"
        :rules="formRules"
        :model="dataForm"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item prop="payType" label="付款方式：">
            <el-input v-model="dataForm.payType" size="mini" type="text"
                      placeholder="请输入付款方式"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="payNo" label="付款凭证号：">
            <el-input v-model="dataForm.payNo" size="mini" clearable type="text"
                      placeholder="请输入付款凭证号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="payTime" label="付款时间：">
            <el-date-picker type="date" v-model="dataForm.payTime" size="mini"
                            value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="付款金额：">
            <el-input v-model="totalAmount" size="mini" clearable type="text"
                      placeholder="请输入付款金额" @change="totalAmountChanged"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <SweetTable ref="table" :data="dataList" :height="500" :is-page="false">
        <el-table-column label="订单编号" width="160" prop="orderCode" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="工厂名称" width="160" prop="factoryName" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品番号" width="160" prop="product.code" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="SKU" width="100" prop="product.skuCode" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品名" align="center" prop="product.name" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="中文品名" align="center" prop="product.nameZh" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="颜色" prop="product.color" header-align="center" align="center" width="100"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="规格" prop="product.size" header-align="center" align="center" width="100"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="发票号" prop="receiptCode" header-align="center" align="center"></el-table-column>
        <el-table-column label="入库时间" prop="operateDate" header-align="center" align="center"
                         width="160"></el-table-column>
        <el-table-column label="数量" prop="count" header-align="center" align="center"></el-table-column>
        <el-table-column label="开票单价" prop="price" header-align="center" align="center"></el-table-column>
        <el-table-column label="总金额" prop="totalAmount" header-align="center" align="center"></el-table-column>
        <el-table-column label="已付款" prop="price" header-align="center" align="center"></el-table-column>
        <el-table-column label="未付款" prop="price" header-align="center" align="center"></el-table-column>
      </SweetTable>
    </el-form>

    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import VxeTable from '@/mixins/vxe-table'

export default {
  name: 'pay-dialog',
  mixins: [VxeTable],
  data () {
    return {
      totalAmount: 0,
      tableConfig: {
        autoHeight: false,
        footerColumn: ['totalAmount', 'payedAmount', 'unPayAmount', 'payAmount']
      },
      dataForm: {
        payType: '',
        payTime: ''
      },
      dataList: [],
      visible: false,
      validRules: {
        payType: [
          { required: true, message: '请填写付款方式' }
        ],
        payNo: [
          { required: true, message: '请填写付款凭证号' }
        ],
        payAmount: [
          { required: true, message: '请填写付款金额' }
        ]
      }
    }
  },
  methods: {
    batchSet () {
      this.dataList.forEach(row => {
        if (this.dataForm.payTime && !row.payTime) {
          row.payTime = this.dataForm.payTime
        }
        if (this.dataForm.payType && !row.payType) {
          row.payType = this.dataForm.payType
        }
      })
      this.dataForm.payTime = ''
      this.dataForm.payType = ''
    },
    updateFooterEvent () {
      const $table = this.$refs[this.tableConfig.tableName]
      $table.updateFooter()
    },
    init () {
      this.visible = true
    },
    dataFormSubmitHandle () {
      this.$refs[this.tableConfig.tableName].fullValidate(true, (errors) => {
        if (errors) {
          return
        }
        this.doSave()
      })
    },
    cancel () {
      this.visible = false
    },
    async doSave () {
      let postForm = [...this.dataList]
      const { data: res } = await this.$http.post(`/fund/pay/log/save`, postForm)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.$message.success('保存成功')
      this.$emit('complete')
      this.cancel()
    }
  }
}
</script>

<style scoped>

</style>
